import { useUser } from "../../../hook";
import { withLandingProcedureWraper } from "../../procedure";
import CountDocumentPreview from "./CountDocumentPreview";
import CountDocumentPreviewAdmin from "./CountDocumentPreviewAdmin";
import { DocumentPublishUserDepartment } from "./DocumentPublishUserDepartment";
import { StatisticDistributionDocumentPage } from "./DocumentStatisticByUserDepartment";
import { UserDocumentTable } from "./UserDocumentTable";
import { UserDocumentTableAdmin } from "./UserDocumentTableAdmin";
import "./index.scss";

export const LadingDocumentPage = withLandingProcedureWraper(() => {
  const { userAdmin } = useUser();

  return (
    <div className="document-landing-page">
      {!userAdmin?.id ? (
        <>
          <CountDocumentPreview />
          <UserDocumentTable />
        </>
      ) : (
        <>
          <CountDocumentPreviewAdmin />
          <UserDocumentTableAdmin />
          <StatisticDistributionDocumentPage />
          <DocumentPublishUserDepartment />
        </>
      )}
    </div>
  );
});
